import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SubCtx = createContext(null);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);

  const refresh = async () => {
    if (!user) return setSub(null);
    try { const r = await api.get("/subscription"); setSub(r.data); } catch {}
  };

  useEffect(() => { refresh(); }, [user?.org_id]);

  // Fall back to plan.modules if a legacy backend returns an outdated top-level modules array.
  const modules = sub?.modules?.length ? sub.modules : (sub?.plan?.modules || []);
  const hasModule = (m) => modules.includes(m);
  return (
    <SubCtx.Provider value={{ sub, modules, hasModule, refresh }}>{children}</SubCtx.Provider>
  );
}

export const useSubscription = () => useContext(SubCtx) || { sub: null, modules: [], hasModule: () => true, refresh: () => {} };
